import { Modal, ModalContent, ModalWrapper, Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { ModalHeaderDefault } from '@/shared/ui/modal';

import { useRecordingMobileLockModalStore } from '../../model/useRecordingMobileLockModalStore';
import mobileLockIllustration from '../assets/mobile-lock-illustration.png';
import { SBottomSpacer, SIllustration } from './styled';

const RecordingMobileLockModalComponent = () => {
  const close = useRecordingMobileLockModalStore((s) => s.close);

  return (
    <Modal size="xs" open onClose={close}>
      <ModalHeaderDefault title="Desktop required" onClose={close} />
      <ModalContent sx={{ px: 16 }} noPadding>
        <Stack alignItems="center" gap={20} sx={{ borderRadius: 14, p: 20 }} width="100%">
          <SIllustration
            alt=""
            data-testid="recording-mobile-lock-illustration"
            src={mobileLockIllustration}
          />
          <Stack alignItems="center" gap={8} width="100%">
            <Typography
              sx={{
                '@media (min-width: 360px)': {
                  whiteSpace: 'nowrap',
                },
              }}
              color="grey.900"
              textAlign="center"
              variant="body-1-md"
            >
              Open Rask on your computer to record your screen
            </Typography>
            <Typography color="grey.500" maxWidth={286} textAlign="center" variant="body-2">
              Rask cleans up speech, adds zooms, and prepares a polished video.
            </Typography>
          </Stack>
        </Stack>
        <SBottomSpacer />
      </ModalContent>
    </Modal>
  );
};

export const RecordingMobileLockModal = () => (
  <ModalWrapper hook={useRecordingMobileLockModalStore}>
    <RecordingMobileLockModalComponent />
  </ModalWrapper>
);
